define('formkit/view/form.object/data.label.selector.view',['require','exports','module','underscore','backbone','uikit/uikit','../../templates','../../extend.util'],function(require ,exports, module){
  var _          = require('underscore');
  var Backbone   = require('backbone');
  var UIKit      = require('uikit/uikit');
  var Templates  = require('../../templates');
  var ExtendUtil = require('../../extend.util');

  var DataLabelMenuView = UIKit.CheckboxGroup.extend({
    childViewBehaviors: {
      setSelectedClassOnView: {
        behaviorClass: Mn.Behavior.extend({
          evaluateCurrentStateAndApplyClass: function(newValue) {
            if (newValue) {
              this.view.$el.addClass('selected');
            } else {
              this.view.$el.removeClass('selected');
            }
          },

          onFirstBeforeRender: function() {
            this.evaluateCurrentStateAndApplyClass(!!this.view.model.get('selected'));

            this.listenTo(this.view, 'proxyView:change:value', function(view, view2, newValue, oldValue){
              this.evaluateCurrentStateAndApplyClass(newValue);
            });
          }
        })
      },
    },

    childView: UIKit.Checkbox.extend({
      // override the events object to prevent checkbox change events from being fired twice
      // TODO: fix this in UIKit
      events: {
        'keydown @ui.input': function(ev) {
          if (!ev.ctrlKey && (ev.keyCode == KeyCodes.ENTER_KEY || ev.keyCode == KeyCodes.SPACE_KEY)) {
            this.ui.input.focus();
          }
        }
      },

      // override UIKit.Checkbox#syncValueWithDom so we can inject a custom event.  We'll handoff checkbox synching
      // to the confirmation modal instead
      syncValueWithDom: function() {
        var isChecked = this.$el.checkbox('is checked');

        if (this.getBoolOption('readonly')) {
          if (isChecked !== this.value) {
            this.applyCheckValue();
          }
        } else if (this.value !== isChecked) {
          this.trigger('datalabel:selected');
        }
      }
    }),

    buildChildView: function(child, ChildViewClass, childViewOptions) {
        ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, { behaviors: this.childViewBehaviors });

        return Mn.CollectionView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
      },

    initialize: function() {
      UIKit.CheckboxGroup.prototype.initialize.apply(this, arguments);

      this.collection = this.templateObjectModel.getDataLabelsCollection();
      this.promoteSelectedLabelToFirst();
    },

    promoteSelectedLabelToFirst: function() {
      var templateObjectModel = this.getOption('templateObjectModel');
      var currentDataLabelModel = templateObjectModel.get('dataLabel')
                                    ? templateObjectModel.findSelectedDataLabelModelByValue(templateObjectModel.getDataLabelValue())
                                    : null;

      if (currentDataLabelModel) {
        this.collection.remove(currentDataLabelModel, { silent: true });
        this.collection.unshift(currentDataLabelModel, { silent: true });
        this.setCurrentDataLabelAsSelected(currentDataLabelModel);
      }
    },

    setCurrentDataLabelAsSelected: function(currentDataLabelModel) {
      var previousDataLabelModel = this.collection.findWhere({ selected: true });
      if (previousDataLabelModel) {
        previousDataLabelModel.set({ selected: false });
      }
      currentDataLabelModel.set({ selected: true });
    }
  });

  var DataLabelSelectorView = UIKit.ItemView.extend({
    className: 'ui data-label-selector',

    template: Templates.App['data.label.selector'],

    options: {
      readonly: false,
      text: '',
    },

    forceUpdate: {
      text: true,
    },

    ui: {
      dataLabelMenu: '.data-label-menu'
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);

      this.on('tagMenuView:childview:proxyView:datalabel:selected', function(tagMenuView, proxyView, radioButtonView) {
        var dataLabelSelectorView = this;

        var confirmationModal = this.form.getConfirmationModal({
          closable: false,
          headerText: 'This Action Will Update the Label Name',
          text: 'Updating the label will reflect in all reports and integrations. The data history associated with the current label name will not be associated with the new one. Are you sure you want to change it?',
          confirmButtonText: 'Update Label',
          icon: 'ban',
          onDeny: function() {
            radioButtonView.model.set({ selected: false });
            radioButtonView.applyCheckValue();
            // if we have added user defined label and if the current model is still associated with the dataLabelsCollection...
            // TODO: figure out why this is being triggered twice so we don't pass by here a second time after the model has been removed from the collection
            if (radioButtonView.model.get('cayuseLabel') === false && radioButtonView.model.collection) {
              radioButtonView.model.collection.remove(radioButtonView.model);
            }
          },
          onConfirm: function() {
            // set the radio button value to true
            radioButtonView._setOption('value', true, { internal: radioButtonView });
          }
        });

        confirmationModal.visible = true;
      });
    },

    onFirstBeforeRender: function() {
      var dataLabelsCollection = this.model.getDataLabelsCollection();

      // bind the dataLabel attributes to the selected model's attributes from the dataLabelsCollection
      this.listenTo(dataLabelsCollection,'change:selected', function(selectedDataLabelModel, checkedValue) {
        var dataLabel = this.model.get('dataLabel');
        var dataLabelSelectorView = this;

        if (checkedValue) {
          this.model.set('dataLabel', selectedDataLabelModel);
          dataLabelSelectorView.toggleButtonView.active = false;
        }
      });
    },

    behaviors: {
      manageUIState: {
        behaviorClass: Mn.Behavior.extend({
          setViewText: function(text) {
            this.view.text = text;
          },

          onFirstBeforeRender: function() {
            // toggle the data label menu on button activation
            this.listenTo(this.view, 'toggleButtonView:change:active', function(view, model, newValue, oldValue) {
              if (newValue) {
                this.ui.dataLabelMenu.addClass('visible');
              } else {
                this.ui.dataLabelMenu.removeClass('visible');
              }
            });

            // initialize and update view text
            if (this.view.model.get('dataLabel')) {
              this.setViewText(this.view.model.getDataLabelValue());
            }

            this.listenTo(this.view.model, 'change:dataLabel', function(viewModel, dataLabelModel) {
              this.setViewText(viewModel.getDataLabelValue())
            });
          }
        })
      },
    },

    internalViewOptions: {
      toggleButtonView: {
        type: UIKit.Button,
        size: UIKit.Button.SMALL,
        icon: 'tag',
        behaviors: {
          handleToggleButtonPressBehavior: {
            behaviorClass: Mn.Behavior.extend({
              onRender: function() {
                this.listenTo(this.view, 'press', function(){
                  this.view.active = !this.view.active;
                })
              }
            })
          }
        }
      },

      userDefinedLabelInputView: function() {
        var dataLabelSelectorView = this;

        return {
          type: UIKit.Input,
          placeholder: 'Enter a new label...',
          model: this.model,
          behaviors: {
            handleUserDefinedLabel: {
              behaviorClass: Mn.Behavior.extend({
                insertDataLabelIfUnique: function(value) {
                  var dataLabelsCollection = this.view.model.getDataLabelsCollection();
                  var selectedDataLabel = this.view.model.findSelectedDataLabelModelByValue(value);

                  if (!selectedDataLabel) {
                    // Add user defined label as the first data label in the list if it doesn't already exist
                    dataLabelsCollection.add([{
                      cayuseLabel: false,
                      value: value
                    }], { at: 0 });
                  } else {
                    // or if it does exist, set the checkbox at the Semantic UI level and let that event bubble up
                    var selectedLabelView = dataLabelSelectorView.tagMenuView.children.findByModel(selectedDataLabel);

                    selectedLabelView.proxyView.$el.checkbox('check');
                  }

                },

                onFirstBeforeRender: function() {
                  this.listenTo(this.view, 'enter blur', function(){
                    if (this.view.value !== null) {
                      this.insertDataLabelIfUnique(this.view.value);
                      this.view.value = null;
                    }
                  });
                }
              })
            }
          }
        }
      },

      tagMenuView: function() {
        return {
          type: DataLabelMenuView,
          templateObjectModel: this.model,
          radio: true,
          childViewOptions: {
            useViewIdAsId: true,
            radio: true,
            bindings: {
              text: 'value',
              value: 'selected',
            }
          },
        }
      }
    },
  });

  DataLabelSelectorView.DataLabelMenuView = DataLabelMenuView;

  module.exports = DataLabelSelectorView
});

